import $                        from 'jquery';
import BasePropertyView         from 'BasePropertyView.js';
import contentTemplate          from 'properties/test-description.ejs';

class TestDescriptionView extends BasePropertyView {

    initialize( opts ) {
        this.options = opts || {};
        this.tagName = 'div';
        this.id = opts.el;
        this.factoryKey = opts.factoryKey;

        this.template = contentTemplate;

        this.events = {
            'change input[type=text]':'updateValue',
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus'
        };

        return this;
    }

    updateValue(ev){
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.target.value;
        this.model.set(propName,propVal);
    }

    render() {
        this.$el.empty();
        this.$el.html(this.template(this.model.toJSON()));

        this.delegateEvents();
        return this;
    }
}

export default TestDescriptionView;